import {
  getURLParamValue
} from '../global/_getURLParamValue';
import {
  getUrlVars,
  getUrlVar
} from '../global/_getUrlVars';

const tap2zoom = () => {
  $('.mainImage, .chunk').on('click', function() {
    var imgSrc = ($(this).attr('src') !== undefined) ? $(this).attr('src') : $(this).find('img').attr('src'),
      imageURLSplit = imgSrc.split('/'),
      imageName = imageURLSplit[imageURLSplit.length - 1].split('.jpg').join('');
    openPhotoSwipe(imageName);
    return false;
  });
};

const setupPhotoSwipe_shoppingbag = (that) => {
  var imgSrc = that.attr('src'),
    imageURLSplit = imgSrc.split('/'),
    imageName = imageURLSplit[imageURLSplit.length - 1].split('.jpg').join('');
  openPhotoSwipe_shoppingbag(that, imageName);
}

const tap2zoom_wl = () => {
  $('#wishlist-shopping-bag .mainImageBtn').on('click', function() {
    setupPhotoSwipe_shoppingbag($(this).children('img'));
    if ($(this).children('img').length > 0 && $('img.pswp__img').length > 0) {
      if ($(this).children('img').attr('alt') != undefined) {
        var copyAlt = $(this).children('img').attr('alt');
        $('img.pswp__img').attr('alt', copyAlt);
      }
    }
    if ($('div[aria-hidden="false"].pswp').length > 0){
      $('div[aria-hidden="false"].pswp').focus();
    }
    var modal = document.querySelector('[role="dialog"][aria-hidden="false"]')
    var firstFocusableElement = modal.querySelector('.first-focusable-element');
    var lastFocusableElement = modal.querySelector('.last-focusable-element');
    firstFocusableElement.focus();

    modal.addEventListener('keydown', function(e) {
      if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
      } else if(document.activeElement == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    });
    return false;
  });
};

const tap2zoom_shoppingbag = () => {
  $('#shopping-bag .mainImageBtn, #registry-bag .mainImageBtn').on('click', function() {
    setupPhotoSwipe_shoppingbag($(this).children('img'));
    if ($(this).children('img').length > 0 && $('img.pswp__img').length > 0) {
      if ($(this).children('img').attr('alt') != undefined){
        var copyAlt = $(this).children('img').attr('alt');
        $('img.pswp__img').attr('alt', copyAlt);
      }
    }
    if ($('div[aria-hidden="false"].pswp').length > 0) {
      $('div[aria-hidden="false"].pswp').focus();
    }

    var modal = document.querySelector('[role="dialog"][aria-hidden="false"]')
    var firstFocusableElement = modal.querySelector('.first-focusable-element');
    var lastFocusableElement = modal.querySelector('.last-focusable-element');
    firstFocusableElement.focus();

    modal.addEventListener('keydown', function(e) {
      if(e.target == firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
      } else if(document.activeElement == lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
      }
    });
  });
}

const initializeGallery = (items) => {
  let options = {
    history: false,
    focus: false,
    galleryPIDs: false,
    showAnimationDuration: 0,
    hideAnimationDuration: 0
  };
  window.gallery = new PhotoSwipe(document.querySelectorAll('.pswp')[0], PhotoSwipeUI_Default, items, options);
  window.gallery.init();
  $('.pswp__button--share').hide();
  $('#myDillardsBar').hide();
  $('.oo_tab_right').each(function() {
    $(this).hide();
  });
  window.gallery.listen('close', function() {
    $('#myDillardsBar').show();
    $('.oo_tab_right').each(function() {
      $(this).show();
    });
  });
}

const openPhotoSwipe_shoppingbag = (that, productID_clicked) => {
  var items = [];
  const buildPhotoSwipe = (that) => {
    items.push({
      src: $(that).attr('src').split('/alt/').join('/zoom/').split('/productItem/').join('/zoom/'),
      w: 880,
      h: 1020
    });
  }
  buildPhotoSwipe(that);
  // define options (if needed)
  initializeGallery(items);
};

const openPhotoSwipe = (productID_clicked) => {
  var items = [],
    n = 0,
    index = 0;
  const buildPhotoSwipe = (that) => {
    var imgSrc = that.attr('src'),
      imgSplit = imgSrc.split('/'),
      currentImage = imgSplit[imgSplit.length - 1].split('.jpg').join(''),
      num = n++;
    if (currentImage == productID_clicked) index = num;
    items.push({
      src: $(that).attr('src').split('/alt/').join('/zoom/').split('/productItem/').join('/zoom/'),
      w: 880,
      h: 1020
    });
  }
  if ($('.alt-image-list-container').length > 0) {
    $('.alt-image-list-container img').each(function() {
      buildPhotoSwipe($(this));
    });
  } else {
    $('.mainImage').each(function() {
      buildPhotoSwipe($(this));
    });
  };
  // define options (if needed)
  initializeGallery(items);
  window.gallery.goTo(index);
};

const allDevicesProductImage = () => {
  $('.alt-image-nav-up, .alt-image-nav-down, .alt-image-nav-left, .alt-image-nav-right').on('click', function() {
    var scrollUp = $(this).hasClass('alt-image-nav-up'),
      scrollDown = $(this).hasClass('alt-image-nav-down'),
      scrollLeft = $(this).hasClass('alt-image-nav-left'),
      scrollRight = $(this).hasClass('alt-image-nav-right'),
      $altImageUL = $('.alt-image-list-container ul'),
      topPos = ($altImageUL).position().top,
      leftPos = ($altImageUL).position().left,
      containerHeight = parseInt($('#alt-image-container').height(), 10),
      containerWidth = parseInt($('#alt-image-container').width(), 10),
      itemsHeight = parseInt($altImageUL.height(), 10),
      itemsWidth = $('.alt-image-list-container ul li').length * 75,
      stopVertScroll = (itemsHeight + topPos) > (containerHeight),
      stopHorzScroll = (itemsWidth + leftPos) > (containerWidth - 28),
      scrollSpeed = 75;

    if (scrollDown && stopVertScroll) {
      $('.alt-image-nav-up').removeClass('disabled-arrow');
      $($altImageUL).animate({
        'top': "-=90"
      }, scrollSpeed);
      if ((itemsHeight + (topPos - 90)) < (containerHeight)) $('.alt-image-nav-down').addClass('disabled-arrow');
    }
    if (scrollUp && topPos < 0) {
      $('.alt-image-nav-down').removeClass('disabled-arrow');
      $($altImageUL).animate({
        'top': "+=90"
      }, scrollSpeed);
      if ((topPos * -1) < 90) $('.alt-image-nav-up').addClass('disabled-arrow');
    }
    if (scrollRight && stopHorzScroll) {
      $('.alt-image-nav-left').removeClass('disabled-arrow');
      $($altImageUL).css({
        'left': "-=75"
      }, scrollSpeed);
      if ((itemsWidth + (leftPos - 75)) < (containerWidth - 28)) $('.alt-image-nav-right').addClass('disabled-arrow');
    }
    if (scrollLeft && leftPos < 0) {
      $('.alt-image-nav-right').removeClass('disabled-arrow');
      $($altImageUL).css({
        'left': "+=75"
      }, scrollSpeed);
      if (leftPos > -130) $('.alt-image-nav-left').addClass('disabled-arrow');
    }
  });

  //Javascript below resets rec and alt image left position. Needed when iPad is rotated
  //  resetAltImgContainer();
};

const allDevicesHideSingleAltImage = () => {
  var altImageListSize = $(".alt-image-list-container ul li").length,
    altImageContainer = $(".alt-image-list-container");
  if (altImageListSize == 1) {
    var altImage = $(".alt-image-tile").attr('data-fullimage').replace("/", "").trim(),
      defaultMainImage = unescape(getUrlVar("di")),
      altIsDefault = altImage == defaultMainImage,
      defaultIsBlank = defaultMainImage == "";
    if (altIsDefault || defaultIsBlank) altImageContainer.hide();
  }
};

const colorSelectChange = (fullImageRef) => {
  $('.color-select-group select, .color-select select').each(function() {
    let foundColor = $(this).find('option[data-fullimage="' + fullImageRef + '"]').val();
    if (foundColor) $(this).val(foundColor).trigger('change');
  });
}

const allDevicesAltImageClickSetup = () => {
  $.each($('.alt-image-list-container').find('img'), function() {
    $(this).on('click', function() {
      var productImg = '';
      if (!$('.desktopPage').length > 0) {
        var activeImg = ($(this).attr('src') !== "") ? $(this).attr('src') : $(this).data('alts');
        productImg = activeImg;
        let altTwist = $(this).data('twist').split('-')[2];
        $('#layoutProduct .slickWrapper').slick('slickGoTo', altTwist);
        let currentImg = $('div.chunk.slick-active img');
        if (currentImg.attr('src') === undefined || currentImg.attr('src') === '')
          currentImg.attr("src", currentImg.data('alts'));
      } else
        productImg = $(this).parents('#productImageContain').find('.mainImage').attr("src");
      let fullImageRef = $(this).data('fullimage').split("__")[0];
      var currentColorVal = $('.color-select').val(),
        currentColor = '';
      $('.color-select option').each(function() {
        if ($(this).val() === currentColorVal) {
          currentColor = $(this).data('fullimage');
          return false;
        }
      });
      if (fullImageRef !== currentColor)
        colorSelectChange(fullImageRef);
      let previewSwatches = $('.preview-color-container ul.swatch-list').find('img[data-fullimage="' + fullImageRef + '"]');
      $.each(previewSwatches, function() {
        $(this).trigger('click');
      });
      if ($('.desktopPage').length > 0) {
        if (productImg.indexOf('/assets/img/') > -1) {
          $(this).parents('#productImageContain').find('.mainImage').attr('src', $(this).attr('src').split('/alt/').join('/main/'));
        } else {
          replaceImage($(this).parents('#productImageContain').find('.mainImage'), $(this).attr('src'));
        }
      }
      return false;
    });
  });
};


const allDevicesProductImgMissing = () => {
  $('img.mainImage').on('error', function() {
    $(this).attr('src', '//dimg.dillards.com/is/image/DillardsZoom/nav/error/missing-full-img.jpg');
  });
};

const loadDefaultImg_desktop = () => {
  if ($('.bundle-display-page').length == 0 && $('.e-card-page').length == 0) {
    var diParam = getUrlVar("di");
    if (diParam != undefined && diParam != "")
      replaceImage($('.mainImage'), unescape(getUrlVar("di")));
  }
};

const replaceImage = (imgSelector, newImage) => {
  var source = imgSelector.attr('src'),
    oldImgSplit = source.split('/'),
    newImgSplit = newImage.split('/');
    //NEED TO KNOW WHY THIS IS HERE
    oldImgSplit[oldImgSplit?.length - 1] = newImgSplit[newImgSplit?.length - 1];
    var newImageWithPath = oldImgSplit.join('/');
    if (newImageWithPath.split('.jpg').length == 1)
      newImageWithPath += '.jpg';
    imgSelector.attr('src', newImageWithPath);
};

export {
  allDevicesAltImageClickSetup,
  loadDefaultImg_desktop,
  openPhotoSwipe,
  allDevicesProductImage,
  allDevicesProductImgMissing,
  allDevicesHideSingleAltImage,
  colorSelectChange,
  tap2zoom,
  tap2zoom_wl,
  tap2zoom_shoppingbag,
  replaceImage
}
